module.exports = __webpack_public_path__ + "static/img/AUDI.b25daee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/AUDI.png
// module id = ALIF
// module chunks = 1